import React, {useEffect, useMemo, useState} from "react";
import clsx from "clsx";
import Select from "react-select";
import {keepPreviousData, useQuery} from "@tanstack/react-query";
import {getProductsOptions} from "../../_requests";
import ProductOption from "./productConfigs/ProductOption";
import ProductMatch from "./productConfigs/ProductMatch";

export default function ProductConfigs({productConfigs, showSelectors, _onActiveProductChange}) {
    const [ configOptions, setConfigOptions ] = useState([]);
    const [ activeConfigOption, setActiveConfigOption ] = useState(1);
    const [ activeProductConfiguration, setActiveProductConfiguration ] = useState(0);

    const optionsQuery =
        useQuery({
            queryKey: ['options', {ids : productConfigs.ids}],
            queryFn: () => getProductsOptions({ids : productConfigs.ids}),
            placeholderData: keepPreviousData,
            staleTime: 1 * 60 * 1000,
            cacheTime: 5 * 60 * 1000,
            enabled: productConfigs.active.length > 0 ? true : false,
            refetchOnWindowFocus: false
        })
    useEffect(() =>{
        if(optionsQuery.data) {
            let activeProduct = optionsQuery.data.options[productConfigs.ids[0]];
            let options = [];
            if(activeProduct != undefined) {
                if (activeProduct.similar) {
                    options.push({
                        value: 1,
                        label: "Similar",
                    })
                    setActiveConfigOption(1);
                }
                if (activeProduct.complementary) {
                    options.push({
                        value: 2,
                        label: "Complementary",
                    })
                    if (activeProduct.similar == undefined) setActiveConfigOption(2);
                }
                if (activeProduct.amazonMatches) {
                    options.push({
                        value: 3,
                        label: "Amazon Matches",
                    })
                    setActiveConfigOption(3);
                }
            } else setActiveConfigOption(1);
            setConfigOptions(options);
        }
    }, [optionsQuery.data])

    const _onProductConfigActiveChange = (e, product) => {
        e.preventDefault();
        setActiveProductConfiguration(product.id);
        _onActiveProductChange(product, true);
    };

    // Generate options list
    const optionsList = useMemo(() => {
        if(optionsQuery.data != undefined && optionsQuery.data.options != undefined) {
            let activeProduct = optionsQuery.data.options[productConfigs.ids[0]];
            if (activeProduct != undefined) {
                let temp = [];
                let count = 0;
                let optionsList = [];
                if (activeConfigOption == 1 && activeProduct.similar != undefined) {
                    Object.keys(activeProduct.similar).forEach(key => {
                        temp.push(activeProduct.similar[key]);
                    });
                } else if (activeConfigOption == 2 && activeProduct.complementary != undefined) {
                    Object.keys(activeProduct.complementary).forEach(key => {
                        temp.push(activeProduct.complementary[key]);
                    });
                } else if (activeConfigOption == 3 && activeProduct.amazonMatches != undefined) {
                    Object.keys(activeProduct.amazonMatches).forEach(key => {
                        temp.push(activeProduct.amazonMatches[key]);
                    });
                }
                if(activeConfigOption == 1 || activeConfigOption ==2) {
                    optionsList = temp.map((node, i) =>
                        (<ProductOption
                            key={i}
                            product={node}
                            isActiveProduct={!productConfigs.reset && parseInt(activeProductConfiguration) == parseInt(node.id)}
                            _onProductConfigActiveChange={_onProductConfigActiveChange}
                        />)
                    )
                } else {
                    optionsList = temp.map((node, i) =>
                        (<ProductMatch
                            key={i}
                            product={node}
                        />)
                    )
                }
                return optionsList;
            }
        }
    }, [optionsQuery.data, activeProductConfiguration, productConfigs.reset, activeConfigOption]);

    return productConfigs.show && productConfigs.active.length > 0 &&
        <div id="vz_product_config" className="card card-flush shadow-sm bg-white mw-sm-425px mw-md-600px">
            <div className="card-header px-3 py-0 min-h-50px flex-nowrap">
                <h3 className="card-title fs-6">Product Options</h3>
                <div className="card-toolbar w-200px">
                    <Select
                        name="productOption"
                        className='react-select-styled react-select-solid react-select-sm'
                        classNamePrefix='react-select'
                        options={configOptions}
                        value={configOptions.filter(option => option.value == activeConfigOption)}
                        // defaultValue = {
                        //     configOptions.filter(option => option.value == activeConfigOption)
                        // }
                        onChange={(assigned) =>
                            setActiveConfigOption(assigned.value)
                        }
                    />
                </div>
            </div>
            <div className="card-body px-3 py-2 pb-4">
                <div className="overflow-auto d-flex align-items-center w-100">
                    {optionsList}
                </div>
            </div>
            {/* todo: Will do it when we will want to work with all active products */}
            {/*<div className="card-footer p-0">*/}
            {/*    <div className="separator my-2"></div>*/}
            {/*    <ul className="nav nav-pills nav-pills-custom justify-content-center" role="tablist">*/}
            {/*        <li className="nav-item" role="presentation">*/}
            {/*            <a className="nav-link d-flex justify-content-between flex-column flex-center overflow-hidden active w-60px h-60px py-4"*/}
            {/*               data-bs-toggle="pill" href="#kt_stats_widget_2_tab_1" aria-selected="true" role="tab">*/}
            {/*                <div className="nav-icon">*/}
            {/*                    <img alt="" src="/metronic8/demo18/assets/media/svg/products-categories/t-shirt.svg" className="" />*/}
            {/*                </div>*/}

            {/*                <span className="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>*/}
            {/*            </a>*/}
            {/*        </li>*/}

            {/*        <li className="nav-item" role="presentation">*/}
            {/*            <a className="nav-link d-flex justify-content-between flex-column flex-center overflow-hidden w-60px h-60px py-4"*/}
            {/*               data-bs-toggle="pill" href="#kt_stats_widget_2_tab_2" aria-selected="false" tabIndex="-1"*/}
            {/*               role="tab">*/}
            {/*                <div className="nav-icon">*/}
            {/*                    <img alt="" src="/metronic8/demo18/assets/media/svg/products-categories/gaming.svg" className="" />*/}
            {/*                </div>*/}

            {/*                <span className="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>*/}
            {/*            </a>*/}
            {/*        </li>*/}

            {/*    </ul>*/}
            {/*</div>*/}
        </div>
}